import {CabinetMesh} from 'components/customer/RoomPlanner/types';
import Camera from 'components/customer/RoomPlanner/lib/use3DRPCameraSetup';
import productEvents from 'components/customer/RoomPlanner/lib/useProductEvents';
import * as THREE from 'three';
import {MutableRefObject} from 'react';

export const deleteCabinetMesh = (
    cabinetGroup: CabinetMesh,
    deleteAll = false,
    cabinetGroupListRef?: React.MutableRefObject<CabinetMesh[]>,
    deletedCabinetsRef?: MutableRefObject<Map<number, CabinetMesh>>
) => {
    if (typeof cabinetGroup.userData.disposeDimensionArrows === 'function') {
        cabinetGroup.userData.disposeDimensionArrows();
    }

    if (typeof cabinetGroup.userData.disposeMovementArrows === 'function') {
        cabinetGroup.userData.disposeMovementArrows();
    }
    if (typeof cabinetGroup.userData.disposeWallDistanceArrows === 'function') {
        cabinetGroup.userData.disposeWallDistanceArrows();
    }

    const currentCabinetGroupList = cabinetGroupListRef?.current || [];

    let updatedList = currentCabinetGroupList.filter(
        (cabinet) => cabinet.uuid !== cabinetGroup.uuid
    );
    let deleteList: CabinetMesh[] = [];

    if (deleteAll) {
        [updatedList, deleteList] = currentCabinetGroupList.reduce(
            ([toKeep, toDelete], cabinet) => {
                if (
                    cabinet.userData.values.id ===
                    cabinetGroup.userData.values.id
                ) {
                    return [toKeep, [...toDelete, cabinet]];
                } else {
                    return [[...toKeep, cabinet], toDelete];
                }
            },
            [[], []] as [CabinetMesh[], CabinetMesh[]]
        );
    }

    cabinetGroupListRef.current = updatedList;
    productEvents.setProducts(updatedList);

    if (deleteAll) {
        deleteList.forEach((cabinet) => {
            deleteMeshAndEvents(cabinet, deletedCabinetsRef);
        });
    } else {
        deleteMeshAndEvents(cabinetGroup, deletedCabinetsRef);
    }
};

const deleteMeshAndEvents = (
    cabinetGroup: CabinetMesh,
    deletedCabinetsRef?: MutableRefObject<Map<number, CabinetMesh>>
) => {
    const cabinetId = Number(cabinetGroup.userData?.values?.id);
    const isStoredForUndo =
        deletedCabinetsRef?.current &&
        deletedCabinetsRef.current.has(cabinetId);

    Camera.scene.remove(cabinetGroup);
    productEvents.clearEvent(cabinetGroup.uuid);

    // Only dispose if the cabinet is not stored for undo
    if (!isStoredForUndo) {
        cabinetGroup.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                (child.geometry as THREE.BufferGeometry).dispose();
                if (child.material instanceof THREE.Material) {
                    child.material.dispose();
                } else if (Array.isArray(child.material)) {
                    (child.material as THREE.Material[]).forEach((material) =>
                        material.dispose()
                    );
                }
            }
        });
    }
};
